// @ts-nocheck
import React from 'react'
import cx from 'classnames'
import * as R from 'ramda'

import { Icon, InfoIcon } from 'components/shared/Icon/Icon'
import { MessageAlert } from 'components/shared/Alerts/MessageAlert/MessageAlert'

import styles from './FormFieldHint.module.scss'

export const FormFieldHint = ({
  className = undefined,
  hint,
  hintVariant = 'neutral',
}) => {
  if (R.not(hint)) {
    return null
  }

  return hintVariant !== 'neutral' ? (
    <MessageAlert
      message={hint}
      size="small"
      variant={hintVariant}
      isInitialised
    />
  ) : (
    <p className={cx(styles.hint, { [className]: Boolean(className) })}>
      <Icon className={styles.icon} icon={InfoIcon} size={16} />
      <span className={styles.text}>{hint}</span>
    </p>
  )
}
